import type {
  FeatureFlag,
  FeatureFlagWithTest,
  FeatureFlagWithComplexTest,
} from './utils/featureFlags/types';

/** for development purposes only, do not use */
export const dummyFeatureFlag: FeatureFlagWithComplexTest<unknown> = {
  name: 'dummyFeatureFlag',
  test: {
    testId: 'dummyTestId',
    defaultGroup: 'default',
    featureCookieGroup: 'feature',
    getTestGroup: () => 'test',
  },
};

export const fewerProductsPerPage: FeatureFlagWithTest = {
  name: 'lowerProductCountPerPage',
  abTest: {
    testId:
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
        ? '2025_4_Artikelreduktion_test'
        : '2025_4_Artikelreduktion',
    isPartOfTestGroup: (variant) => variant.treatment === 'test',
  },
};

export const sustainabilityIcon: FeatureFlagWithTest = {
  name: 'sustainabilityIcon',
  abTest: {
    testId:
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging'
        ? '2025_02_Sustainability_test'
        : '2025_02_Sustainability',
    isPartOfTestGroup: (variant) => variant.treatment === 'test',
  },
};

export const hideGoogleAdsBannerInProductLists: FeatureFlagWithTest = {
  name: 'hideGoogleAdsBannerInProductLists',
  abTest: {
    testId: { staging: '2025_10_google_ads_test', production: '2025_10_google_ads' },
    isPartOfTestGroup: (variant) => variant.treatment === 'test',
  },
};

export const filterSettingsFab: FeatureFlagWithTest = {
  name: 'filterSettingsFab',
  abTest: {
    testId: { staging: '2025_11_fab_test', production: '2025_11_fab' },
    isPartOfTestGroup: (variant) => variant.treatment === 'test',
  },
};
